export default [
    {
        id: 1,
        name_ca: 'Expedients anteriors a 1969. Actualment amb preu de venta lliure',
        name_en: 'Files prior to 1969. Currently with free market sale price',
        name_es: 'Expedientes anteriores a 1969. Actualment con precio de venta libre'
    },
    {
        id: 2,
        name_ca: 'Expedients de 1969 a 1978',
        name_en: 'Files from 1969 to 1978',
        name_es: 'Expedientes de 1969 a 1978'
    },
    {
        id: 3,
        name_ca: 'Expedients de 1979 a 2001',
        name_en: 'Files from 1979 to 2001',
        name_es: 'Expedientes de 1979 a 2001'
    },
    {
        id: 3,
        name_ca: 'Expedients de 2002 i posteriors',
        name_en: 'Files from 2002 and afterwards',
        name_es: 'Expedientes de 2002 y posteriores'
    }
]



// WEBPACK FOOTER //
// ./src/options/protection_types.js